/** Impls dos use cases do Fórum. @since H.2 */
import type {
  ForumTopico, UpsertForumTopicoCommand, ListForumTopicosParams,
  ForumResposta, CorrigirRespostaCommand,
} from '@/domain/model/Forum';
import type { ForumGateway } from '@/application/port/out/ForumGateway';
import type {
  ListForumTopicosUseCase, CreateForumTopicoUseCase, UpdateForumTopicoUseCase,
  EncerrarForumTopicoUseCase, ArquivarForumTopicoUseCase,
  ListForumRespostasUseCase, CorrigirForumRespostaUseCase,
} from '@/application/port/in/ForumUseCase';

export class ListForumTopicos implements ListForumTopicosUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(params: ListForumTopicosParams): Promise<ForumTopico[]> { return this.g.list(params); }
}
export class CreateForumTopico implements CreateForumTopicoUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(cmd: UpsertForumTopicoCommand): Promise<ForumTopico> { return this.g.create(cmd); }
}
export class UpdateForumTopico implements UpdateForumTopicoUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(id: string, cmd: UpsertForumTopicoCommand): Promise<ForumTopico> { return this.g.update(id, cmd); }
}
export class EncerrarForumTopico implements EncerrarForumTopicoUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(id: string): Promise<ForumTopico> { return this.g.encerrar(id); }
}
export class ArquivarForumTopico implements ArquivarForumTopicoUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(id: string): Promise<void> { return this.g.arquivar(id); }
}
export class ListForumRespostas implements ListForumRespostasUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(topicoId: string): Promise<ForumResposta[]> { return this.g.listRespostas(topicoId); }
}
export class CorrigirForumResposta implements CorrigirForumRespostaUseCase {
  constructor(private readonly g: ForumGateway) {}
  execute(respostaId: string, cmd: CorrigirRespostaCommand): Promise<ForumResposta> {
    return this.g.corrigirResposta(respostaId, cmd);
  }
}
